// extracted by mini-css-extract-plugin
export default {"container":"Home_container__JWQdW"};